import {ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, NgZone} from '@angular/core';
import 'rxjs/add/operator/switchMap';
import {alertsLevel, CITY, Colors, ServiceLevelColor, Types} from '../../common/const';
import {environment} from '../../../environments/environment';
import {MapContextService} from 'app/common/map-context.service';
import {Subscription} from 'rxjs/Subscription';
import {groupBy} from '../../common/utils';

@Component({
    selector: 'app-real-time-detail',
    templateUrl: './real-time-detail.component.html',
    styleUrls: ['./real-time-detail.component.scss']
})
export class RealTimeDetailComponent implements OnInit, OnDestroy {

    @Input() map: any;
    @Output() dataLoaded = new EventEmitter();
    @Output() back = new EventEmitter();
    subscription: Subscription;
    types = Types;
    category: any;
    title: string;
    backTitle: string;
    downloadUrl: string;
    stat: any;
    total: number;
    unitLength = environment.unitLength;
    protected ngZone: NgZone

    constructor(
        private mapContextService: MapContextService,
        @Inject(CITY) private city,
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.subscription && !this.subscription.closed) {
            this.subscription.unsubscribe();
        }
    }

    loadDetail(category, title, mode: any = {}) {
        this.backTitle = mode.modeName;
        this.title = title;
        this.category = category;
        this.downloadUrl = category.downloadData;

        this.processData(this.category);
        this.ngZone.run(() => {
            this.category = this.city.find(c => c.mode === mode.mode).types.find(_type => _type.idText === category.idText);
            this.processData(this.category);
            this.cdr.detectChanges();
        });
    }

    refresh(stats) {
        if (this.category !== null) {
            this.stat = stats.results.find((r) => r.category === this.category.id);
        }
    }

    goBack() {
        this.back.emit(true);
        this.stat = null;
        this.category = null;
    }

    toggleList(d) {
        d['showList'] = !d['showList'];
        this.cdr.detectChanges();
    }

    getBarColor(category, subcategory) {
        if (category.id === Types.JAM) {
            return Colors['level' + subcategory];
        } else if (category.idText === 'INTENSITY_LEVELS') {
            const colors = ['#91FF91', '#52FF31', '#08CC22', '#037C1B', '#FFFF00', '#FF8040', '#6600FF', '#6600FF', '#663300'];
            return colors[parseInt(subcategory, 0) - 1];
        } else {
            const alertLevel = alertsLevel(category, subcategory);
            if (alertLevel) {
                return Colors['alert' + (alertLevel.charAt(0).toUpperCase() + alertLevel.slice(1))];
            }
        }
        return Colors.colorPrimaryLight;
    }

    getIntensityName(key) {
        const names = [
            '0-100',
            '100-500',
            '500-1000',
            '1000-2000',
            '2000-3000',
            '3000-5000',
            'Sin datos',
            'Sin datos',
            '5000-10000'
        ];
        return names[key - 1];
    }

    serviceLevelColor(key) {
        return ServiceLevelColor[key.toUpperCase()] || Colors.colorPrimary;
    }

    private processData(category) {
        this.stat = [];
        this.total = category.data ? category.data.length : 0;
        const grouped = groupBy(category.data, category.groupBy || 'level');
        Object.keys(grouped).forEach(key => {
            this.stat.push({key: key, data: grouped[key]});
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time-detail/real-time-detail.component.ts